<div class="row mt-2">
  <div class="col-md-12 order-table">
    <h6>Finance Reports Instructions</h6>
    <div>
      <p>Use the options on the right to select the report you would like to generate.</p>
    </div>
  </div>
</div>
